import Cookies from 'js-cookie';
import {
  CONFIG_VERSION,
  CONFIG_ENVIRONMENT,
  CONFIG_IAB_TCF_CMP_ID,
  CONFIG_IAB_TCF_CMP_VERSION,
  CONFIG_IAB_TCF_SERVICE_SPECIFIC,  
  CONFIG_IAB_TCF_COOKIE_IDENTIFIER,
  COOKIE_IDENTIFIER_IDCC,

  // CONFIG_IAB_TCF_VENDOR_INFONLINE,
  CONFIG_IAB_TCF_VENDOR_ADOBE,
  CONFIG_IAB_TCF_VENDOR_INDEX_EXCHANGE,
  CONFIG_IAB_TCF_VENDOR_AGOF_DAILY_CAMPAIGN_FACTS,
  CONFIG_IAB_TCF_VENDOR_AGOF_DAILY_DIGITAL_FACTS,
  CONFIG_IAB_TCF_VENDOR_XANDR,
  CONFIG_IAB_TCF_VENDOR_CRITEO,
  CONFIG_IAB_TCF_VENDOR_ADITION,
  CONFIG_IAB_TCF_VENDOR_ACTIVE_AGENT,
  CONFIG_IAB_TCF_VENDOR_YIELDLAB,
  CONFIG_IAB_TCF_VENDOR_GOOGLE,
  CONFIG_IAB_TCF_VENDOR_PUBMATIC,
  CONFIG_IAB_TCF_VENDOR_SMART_ADSERVER,
  CONFIG_IAB_TCF_VENDOR_OPEN_X,
  CONFIG_IAB_TCF_VENDOR_IMPROVE_DIGITAL,
  CONFIG_IAB_TCF_VENDOR_RUBICON,
  CONFIG_IAB_TCF_VENDOR_PLISTA,
  CONFIG_IAB_TCF_VENDOR_AD_DEFEND,
  CONFIG_IAB_TCF_VENDOR_TABOOLA,
} from '../config';

/**
 * Returns the value from the IAB TCF cookie
 * Explicit assign an empty string as default, not `null` ...
 * ... otherwise `gdprApplies` would be set implicit to `false`
 * See: https://github.com/InteractiveAdvertisingBureau/iabtcf-es/tree/master/modules/cmpapi#trigger-change-event
 */
export function getTCString(): string {
  return Cookies.get(CONFIG_IAB_TCF_COOKIE_IDENTIFIER) || '';
}

/**
 * Returns the value of the idcc cookie set via updateTCString event
 */
export function getIdcc(): boolean {
  const idccValue: string = Cookies.get(COOKIE_IDENTIFIER_IDCC) || '1';
  return (idccValue === '1' || idccValue === '2') ? true : false;
}

/**
 * Helper function to expose the TCF Api Version
 */
export function getTCFVersion(): string {
  return '2.0';
}

/**
 * Helper function to get an array, containing all relevant vendorIds
 */
export function getVendorArray(): number[] {
  return [
    // CONFIG_IAB_TCF_VENDOR_INFONLINE,
    CONFIG_IAB_TCF_VENDOR_ADOBE,
    CONFIG_IAB_TCF_VENDOR_INDEX_EXCHANGE,
    CONFIG_IAB_TCF_VENDOR_AGOF_DAILY_CAMPAIGN_FACTS,
    CONFIG_IAB_TCF_VENDOR_AGOF_DAILY_DIGITAL_FACTS,
    CONFIG_IAB_TCF_VENDOR_XANDR,
    CONFIG_IAB_TCF_VENDOR_CRITEO,
    CONFIG_IAB_TCF_VENDOR_ADITION,
    CONFIG_IAB_TCF_VENDOR_ACTIVE_AGENT,
    CONFIG_IAB_TCF_VENDOR_YIELDLAB,
    CONFIG_IAB_TCF_VENDOR_GOOGLE,
    CONFIG_IAB_TCF_VENDOR_PUBMATIC,
    CONFIG_IAB_TCF_VENDOR_SMART_ADSERVER,
    CONFIG_IAB_TCF_VENDOR_OPEN_X,
    CONFIG_IAB_TCF_VENDOR_IMPROVE_DIGITAL,
    CONFIG_IAB_TCF_VENDOR_RUBICON,
    CONFIG_IAB_TCF_VENDOR_PLISTA,
    CONFIG_IAB_TCF_VENDOR_AD_DEFEND,
    CONFIG_IAB_TCF_VENDOR_TABOOLA
  ];
}

/**
 * Returns the app information
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getAppInfo(): any {
  return {
    environment: CONFIG_ENVIRONMENT,
    version: CONFIG_VERSION,
    tcf: {
      cmpId: CONFIG_IAB_TCF_CMP_ID,
      cmpVersion: CONFIG_IAB_TCF_CMP_VERSION,
      serviceSpecific: CONFIG_IAB_TCF_SERVICE_SPECIFIC
    }
  };
}
